import {Showable} from "./Switcher";
import {MailOutlined, PhoneOutlined} from "@ant-design/icons";
import EmailLink from "./EmailLink";
import React from "react";

export default ({c}) => {
  let {contact_name, contact_email, contact_phone} = c;
  return <div>
    {contact_name}<br/>
    <Showable v={contact_phone}>
      <PhoneOutlined /> {contact_phone}<br/>
    </Showable>
    <Showable v={contact_email}>
      <MailOutlined /> <EmailLink email={contact_email} />
    </Showable>
  </div>
}
